{
  "clinicalNotes": "病历文书",
  "noteType": "文书类型",
  "author": "作者",
  "dateTime": "日期/时间",
  "content": "内容",
  "addNote": "添加病历",
  "editNote": "编辑病历",
  "signNote": "签署病历",
  "signed": "已签署",
  "unsigned": "未签署",
  "types": {
    "progressNote": "病程记录",
    "admissionNote": "入院记录",
    "dischargeNote": "出院记录",
    "consultNote": "会诊记录",
    "procedureNote": "手术记录"
  },
  "editor": {
    "newNote": "新建病历",
    "titlePlaceholder": "病历标题…",
    "create": "创建",
    "cancel": "取消",
    "cosignFilterLabel": "仅显示需我会签的病历",
    "emptyNoCosign": "没有需要您会签的病历",
    "emptyNoNotes": "暂无病历",
    "emptySelection": "请选择病历或新建一份",
    "emptySelectionHint": "从左侧列表选择,或点击\"+ 新建病历\"开始。",
    "unknownAuthor": "未知",
    "needsCosignBadge": "需会签",
    "amendmentBanner": "病历 #{{parentId}} 的修订 — 原因:{{reason}}",
    "signedBanner": "由 {{name}} 于 {{when}} 签署 — 此病历为只读。",
    "signedByFallback": "医生",
    "saving": "保存中…",
    "autoSaved": "已自动保存",
    "actions": {
      "saveDraft": "保存草稿",
      "signNote": "签署病历",
      "amend": "修订",
      "cosign": "会签",
      "printLabel": "打印病历"
    },
    "copyForward": "沿用上一份病历",
    "copyForwardHint": "将沿用 {{date}} 已签署的病历——请逐项复核并更新",
    "copiedForwardBadge": "沿用"
  },
  "dialog": {
    "sign": {
      "title": "签署病历",
      "body": "确认签署此病历?此操作无法撤销。签署后病历将变为只读。",
      "cancel": "取消",
      "confirm": "确认签署"
    },
    "amend": {
      "title": "修订病历",
      "body": "请提供本次修订的原因。病历将被更新并标记为已修订。",
      "reasonPlaceholder": "修订原因…",
      "cancel": "取消",
      "confirm": "确认修订"
    },
    "cosign": {
      "title": "会签病历",
      "body": "确认会签此病历?这表示您已审阅并认可此病历的内容。",
      "cancel": "取消",
      "confirm": "确认会签"
    }
  },
  "toast": {
    "created": "病历已创建",
    "createFailed": "创建病历失败",
    "titleRequired": "请输入病历标题",
    "draftSaved": "草稿已保存",
    "signed": "病历签署成功",
    "signFailed": "签署病历失败",
    "amended": "病历修订成功",
    "amendFailed": "修订病历失败",
    "amendReasonRequired": "请提供修订原因",
    "cosigned": "病历会签成功",
    "cosignFailed": "会签病历失败"
  },
  "status": {
    "draft": "草稿",
    "unsigned": "未签署",
    "signed": "已签署",
    "amended": "已修订",
    "cosigned": "已会签",
    "cosignNeeded": "需会签",
    "pendingSignature": "待签署",
    "addendum": "补充记录",
    "cosignPending": "待会签"
  },
  "worklist": {
    "title": "未签署病历工作列表",
    "backToDashboard": "工作台",
    "filtersHeading": "筛选",
    "filterAllNoteTypes": "全部文书类型",
    "filterAllStatuses": "全部状态",
    "filterAuthorPlaceholder": "按作者筛选…",
    "dateFromAria": "起始日期",
    "dateToAria": "结束日期",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "noteType": "文书类型",
      "noteTitle": "标题",
      "author": "作者",
      "created": "创建时间",
      "status": "状态",
      "actions": "操作"
    },
    "actions": {
      "signSelected": "签署所选({{count}})",
      "signing": "签署中…",
      "open": "打开",
      "refresh": "刷新"
    },
    "loading": "正在加载病历…",
    "empty": "未找到未签署病历",
    "loadError": "加载未签名病历失败",
    "retry": "重试",
    "toast": {
      "noneSelected": "未选择病历",
      "signed_one": "{{count}} 份病历签署成功",
      "signed_other": "{{count}} 份病历签署成功",
      "signFailed": "部分病历签署失败",
      "partiallySigned_one": "{{count}} 份病历签署成功，{{failed}} 份失败",
      "partiallySigned_other": "{{count}} 份病历签署成功，{{failed}} 份失败"
    }
  },
  "type": {
    "progress": "病程记录",
    "historyPhysical": "H&P",
    "admission": "入院记录",
    "discharge": "出院小结",
    "consult": "会诊记录",
    "procedure": "操作记录",
    "operative": "手术记录",
    "nursing": "护理记录"
  },
  "template": {
    "list": {
      "title": "病历模板",
      "backToDashboard": "工作台",
      "newButton": "新建模板",
      "columns": {
        "name": "名称",
        "noteType": "文书类型",
        "specialty": "科室",
        "sections": "章节",
        "status": "状态",
        "actions": "操作"
      },
      "active": "启用",
      "inactive": "停用",
      "loading": "正在加载模板…",
      "empty": "暂无模板。请创建一个以开始使用。",
      "previewTitle": "模板预览:{{name}}",
      "emptySection": "(空)",
      "tooltips": {
        "preview": "预览",
        "edit": "编辑",
        "activate": "启用",
        "deactivate": "停用"
      },
      "toast": {
        "statusUpdated": "模板状态已更新"
      }
    },
    "form": {
      "editTitle": "编辑模板",
      "createTitle": "创建模板",
      "fields": {
        "name": "模板名称",
        "noteType": "文书类型",
        "specialty": "科室",
        "sections": "章节"
      },
      "required": "*",
      "namePlaceholder": "例如:标准病程记录",
      "selectNoteType": "选择类型…",
      "selectSpecialty": "选择科室…",
      "addSection": "新增章节",
      "sectionNamePlaceholder": "章节名称(例如:主诉)",
      "sectionDefaultPlaceholder": "本章节的默认内容…",
      "cancel": "取消",
      "create": "创建模板",
      "update": "更新模板",
      "toast": {
        "created": "模板已创建",
        "updated": "模板已更新",
        "saveFailed": "保存模板失败",
        "nameAndTypeRequired": "名称与文书类型必填",
        "atLeastOneSection": "至少需要一个章节"
      }
    },
    "specialty": {
      "general": "全科",
      "internalMedicine": "内科",
      "surgery": "外科",
      "pediatrics": "儿科",
      "cardiology": "心内科",
      "neurology": "神经科",
      "orthopedics": "骨科",
      "emergencyMedicine": "急诊医学"
    },
    "scope": {
      "personal": "个人",
      "group": "科室",
      "global": "全院"
    },
    "state": {
      "draft": "草稿",
      "published": "已发布"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "加粗",
      "italic": "斜体",
      "list": "列表",
      "templates": "模板 / 智能短语",
      "saved": "已保存 {{time}}",
      "notSaved": "未保存",
      "charactersLabel": "字符",
      "save": "保存{{noteType}}",
      "placeholder": "开始输入您的{{noteType}}…输入“.”可触发智能短语。",
      "smartPhrases": {
        "patientName": "患者姓名",
        "mrn": "病历号",
        "dateOfBirth": "出生日期",
        "allergies": "过敏史",
        "vitals": "生命体征",
        "medications": "用药",
        "problemList": "问题列表"
      }
    }
  }
}
